module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/307.de6369bc.png";